const productMixesProps = () => ({
  productMixes: {
    type: Object,
    required: true
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  remainProduct: {
    type: Number,
    required: false,
    default: 0
  },
  inCart: {
    type: Number,
    required: false,
    default: 0
  }
})

const productMixesEmits = () => ([
  "onProductIntersect"
])

const useProductMixes = (props) => {
  const isFidelite = computed(() => {
    return props.productMixes.article?.type_avantage === "EC";
  });
  
  const getBadgeVariant = (index) => {
    if (
      props.inCart > 0 &&
      (props.remainProduct === 0 ||
        props.remainProduct === props.productMixes.article.nb_pdt_lot ||
        props.productMixes.article.nb_pdt_lot - props.remainProduct >= index)
    ) {
      return "jauge-full";
    }
    return "check-panachage";
  };
  const getIconVariant = (index) => {
    if (
      (props.inCart > 0 &&
        (props.remainProduct === 0 ||
          props.remainProduct === props.productMixes.article.nb_pdt_lot)) ||
      props.productMixes.article.nb_pdt_lot - props.remainProduct >= index
    ) {
      return "white";
    }
    return "check-panachage";
  };
  const hasCompletedAdvantage = computed(() => {
    return (props.remainProduct === 0 || props.remainProduct === props.productMixes.article.nb_pdt_lot) && props.inCart > 0
  })

  return {
    isFidelite,
    getBadgeVariant,
    getIconVariant,
    hasCompletedAdvantage
  }
}

export {
  productMixesProps,
  productMixesEmits,
  useProductMixes
}